import script from "./UnsavedChangesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&setup=true&lang=js"

import "./UnsavedChangesModal.vue?vue&type=style&index=0&id=fe1a75ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe1a75ce"]])

export default __exports__